import { render } from "./MyQuestion.vue?vue&type=template&id=6e7a9dae&scoped=true"
import script from "./MyQuestion.vue?vue&type=script&lang=js"
export * from "./MyQuestion.vue?vue&type=script&lang=js"

import "./MyQuestion.vue?vue&type=style&index=0&id=6e7a9dae&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7a9dae"]])

export default __exports__